import { useNavigate } from "react-router";

const icons = {
  search: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  ),
  filePlus: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M3 15h6" />
      <path d="M6 12v6" />
    </svg>
  ),
  scissors: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="6" cy="6" r="3" />
      <circle cx="6" cy="18" r="3" />
      <path d="M20 4 8.12 15.88" />
      <path d="M14.47 14.48 20 20" />
      <path d="M8.12 8.12 12 12" />
    </svg>
  ),
  eye: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  clock: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
};

const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iP(hone|ad|od)/.test(navigator.platform);

interface UtilityBarProps {
  onSearch: () => void;
}

export function UtilityBar({ onSearch }: UtilityBarProps) {
  const navigate = useNavigate();

  return (
    <div style={styles.bar}>
      <button className="util-btn" style={styles.searchCell} onClick={onSearch}>
        <span style={styles.searchIcon}>{icons.search}</span>
        <span>search</span>
        <span style={styles.kbdHint}>{isMac ? "⌘k" : "ctrl k"}</span>
      </button>
      <div style={styles.cell}>
        <button
          className="util-btn"
          style={styles.iconBtn}
          title="new document"
          onClick={() => navigate("/templates")}
        >
          {icons.filePlus}
        </button>
        <button
          className="util-btn"
          style={styles.iconBtn}
          title="snippets"
          onClick={() => navigate("/snippets")}
        >
          {icons.scissors}
        </button>
      </div>
      <div style={styles.cell}>
        <button
          className="util-btn"
          style={styles.iconBtn}
          title="live"
          onClick={() => navigate("/live")}
        >
          {icons.eye}
        </button>
        <button
          className="util-btn"
          style={styles.iconBtn}
          title="audit"
          onClick={() => navigate("/audit")}
        >
          {icons.clock}
        </button>
      </div>
      <div style={styles.rest} />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    position: "sticky",
    top: "var(--topnav-height)",
    zIndex: 90,
    display: "flex",
    alignItems: "stretch",
    height: 36,
    background: "var(--comp-paper)",
    borderBottom: "1px solid var(--comp-rule)",
  },
  searchCell: {
    width: "var(--sidebar-width)",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
    padding: "0 var(--space-3)",
    borderRight: "1px solid var(--comp-rule)",
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    color: "var(--fg-3)",
    textAlign: "left",
    borderRadius: 0,
  },
  searchIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 26,
    flexShrink: 0,
  },
  kbdHint: {
    marginLeft: "auto",
    fontSize: 10,
    color: "var(--fg-mute)",
  },
  cell: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "0 6px",
    borderRight: "1px solid var(--comp-rule)",
  },
  iconBtn: {
    width: 26,
    height: 26,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--fg-2)",
    borderRadius: 0,
  },
  rest: {
    flex: 1,
  },
};
